<div class="report-container">

  <div class="report-header">
    <h2 class="report-title">Probate Status Report</h2>
    <button mat-raised-button class="download-btn" (click)="downloadCsv()">
      <mat-icon>download</mat-icon> Download CSV
    </button>
  </div>

  <div class="filter-container">

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Date From</mat-label>
      <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" (dateChange)="loadData()">
      <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Date To</mat-label>
      <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo" (dateChange)="loadData()">
      <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

    <span class="spacer"></span>

    <span class="results-count">{{ dataSource.data.length }} record(s) found</span>

    <mat-paginator #paginator
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[25, 50, 100, 200]"
                   (page)="pageChanged($event)"
                   showFirstLastButtons>
    </mat-paginator>

  </div>

  <div class="table-scroll-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 report-table">

      <ng-container matColumnDef="probateStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.probateStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="deceasedName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Deceased Name</th>
        <td mat-cell *matCellDef="let row">{{ row.deceasedName }}</td>
      </ng-container>

      <ng-container matColumnDef="probateId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Probate ID</th>
        <td mat-cell *matCellDef="let row">{{ row.probateId }}</td>
      </ng-container>

      <ng-container matColumnDef="dateOfProbate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Probate</th>
        <td mat-cell *matCellDef="let row">{{ formatDate(row.dateOfProbate) }}</td>
      </ng-container>

      <ng-container matColumnDef="currentOwner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Owner</th>
        <td mat-cell *matCellDef="let row">{{ row.currentOwner }}</td>
      </ng-container>

      <ng-container matColumnDef="reportingUser">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reporting User</th>
        <td mat-cell *matCellDef="let row">{{ row.reportingUser }}</td>
      </ng-container>

      <ng-container matColumnDef="reportingCompleteDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reporting Complete</th>
        <td mat-cell *matCellDef="let row">{{ formatDate(row.reportingCompleteDate) }}</td>
      </ng-container>

      <ng-container matColumnDef="verificationUser">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Verification User</th>
        <td mat-cell *matCellDef="let row">{{ row.verificationUser }}</td>
      </ng-container>

      <ng-container matColumnDef="verificationCompleteDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Verification Complete</th>
        <td mat-cell *matCellDef="let row">{{ formatDate(row.verificationCompleteDate) }}</td>
      </ng-container>

      <ng-container matColumnDef="firstClientEmailedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>First Alerted</th>
        <td mat-cell *matCellDef="let row">{{ formatDate(row.firstClientEmailedDate) }}</td>
      </ng-container>

      <ng-container matColumnDef="firstInvoiceCreatedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>First Invoiced</th>
        <td mat-cell *matCellDef="let row">{{ formatDate(row.firstInvoiceCreatedDate) }}</td>
      </ng-container>

      <ng-container matColumnDef="ageInDays">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Age (Days)</th>
        <td mat-cell *matCellDef="let row">{{ row.ageInDays }}</td>
      </ng-container>

      <ng-container matColumnDef="reportingTimeFromIssueInDays">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reporting Time (Days)</th>
        <td mat-cell *matCellDef="let row">{{ row.reportingTimeFromIssueInDays }}</td>
      </ng-container>

      <ng-container matColumnDef="verificationTimeFromReportingInDays">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Verification Time (Days)</th>
        <td mat-cell *matCellDef="let row">{{ row.verificationTimeFromReportingInDays }}</td>
      </ng-container>

      <ng-container matColumnDef="totalBequestCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Bequests</th>
        <td mat-cell *matCellDef="let row">{{ row.totalBequestCount }}</td>
      </ng-container>

      <ng-container matColumnDef="pecuniaryBequestCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Pecuniary</th>
        <td mat-cell *matCellDef="let row">{{ row.pecuniaryBequestCount }}</td>
      </ng-container>

      <ng-container matColumnDef="residualBequestCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Residual</th>
        <td mat-cell *matCellDef="let row">{{ row.residualBequestCount }}</td>
      </ng-container>

      <ng-container matColumnDef="effectBequestCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Effect</th>
        <td mat-cell *matCellDef="let row">{{ row.effectBequestCount }}</td>
      </ng-container>

      <ng-container matColumnDef="hadsBequestCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>HADS</th>
        <td mat-cell *matCellDef="let row">{{ row.hadsBequestCount }}</td>
      </ng-container>

      <ng-container matColumnDef="clientCharitableCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Charitable</th>
        <td mat-cell *matCellDef="let row">{{ row.clientCharitableCount }}</td>
      </ng-container>

      <ng-container matColumnDef="nonClientCharitableCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Client Charitable</th>
        <td mat-cell *matCellDef="let row">{{ row.nonClientCharitableCount }}</td>
      </ng-container>

      <ng-container matColumnDef="namedSubscriptionCountThatThisTriggers">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Named Sub Count</th>
        <td mat-cell *matCellDef="let row">{{ row.namedSubscriptionCountThatThisTriggers }}</td>
      </ng-container>

      <ng-container matColumnDef="csvNamesOfNamedSubscriptionCountThatThisTriggers">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Named Subscriptions</th>
        <td mat-cell *matCellDef="let row">{{ row.csvNamesOfNamedSubscriptionCountThatThisTriggers }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">No records found for the selected criteria.</td>
      </tr>

    </table>
  </div>

</div>
